import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetEverything, setCurrentSlide } from 'store/CustomReports/actions'
import SaveDownloadModal from './SaveDownloadModal'
import StepProgress from './StepProgress'
import { stepProgresses } from './data'
import { SET_EXACT_REPORT_TYPE } from 'store/CustomReports/types'
import { SET_COMPLETED_SLIDES } from 'store/CustomReports/types'

const setProgressArray = (generalReportType) => {
  if (generalReportType === null) return ['General Type']
  if (generalReportType === 0) {
    return ['General Type', 'Course Type']
  }
  if (generalReportType === 1) {
    return ['General Type', 'Course Group Type']
  }
}

const Footer = () => {
  const {
    currentSlide,
    finalSlide,
    continueDisabled,
    continueButtonText,
    exactReportType,
    selectedReportType,
    editingReport,
  } = useSelector((store) => store.customReports)

  const dispatch = useDispatch()
  const [showSaveDownloadModal, setShowSaveDownloadModal] = useState(false)

  useEffect(() => {
    console.log('leart35')
    dispatch({ type: SET_EXACT_REPORT_TYPE, payload: null })
  }, [dispatch, selectedReportType])

  useEffect(() => {
    if (editingReport && exactReportType !== null) {
      dispatch({
        type: SET_COMPLETED_SLIDES,
        payload: stepProgresses?.[exactReportType]?.map(
          (el, index) => index + 1
        ),
      })
    }
  }, [editingReport, exactReportType, dispatch])

  return (
    <>
      <div
        className='bg-white shadow p-4 py-5 position-absolute d-flex'
        style={{ bottom: 0, left: 0, right: 0 }}
      >
        <button
          style={{ width: '115px' }}
          onClick={() => {
            if (currentSlide !== 1) {
              dispatch(setCurrentSlide(currentSlide - 1))
            } else {
              dispatch(resetEverything())
            }
          }}
          className='btn btn-info'
        >
          {currentSlide === 1 ? 'Exit' : 'Previous'}
        </button>
        <StepProgress
          steps={
            exactReportType !== null
              ? stepProgresses[exactReportType]
              : setProgressArray(selectedReportType)
          }
        />

        <button
          style={{ width: '115px' }}
          disabled={continueDisabled}
          onClick={() => {
            !finalSlide
              ? dispatch(setCurrentSlide(currentSlide + 1))
              : setShowSaveDownloadModal(true)
          }}
          className={`btn btn-info ml-auto`}
        >
          {continueButtonText}
        </button>
      </div>

      {showSaveDownloadModal && (
        <SaveDownloadModal
          showSaveDownloadModal={showSaveDownloadModal}
          setShowSaveDownloadModal={setShowSaveDownloadModal}
        />
      )}
    </>
  )
}

export default Footer
